import { render } from "./FriendActivity.vue?vue&type=template&id=4edc14cf"
import script from "./FriendActivity.vue?vue&type=script&lang=js"
export * from "./FriendActivity.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__